import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxAuditRoutingModule } from './rx-audit-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RxAuditRoutingModule
  ]
})
export class RxAuditModule { }
